import React from 'react';

import { Nav } from '../components/Nav-ua';
import { Hero } from './parts/Hero-ua';
import { About } from './parts/About-ua';
import { Offer } from './parts/Offer-ua';
import { CTA } from './parts/CTA-ua';
import { Footer } from '../components/Footer-ua';
import { MetaTagsComponent } from '../components/MetaTags';

const Home = () => {
  return (
    <>
      <MetaTagsComponent lang="uk" />
      <Nav />
      <Hero />
      <About />
      <Offer />
      <CTA />
      <Footer />
    </>
  );
};

export { Home }; 